var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCustomerExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_1",
    "data-name": "Artboard \\u2013 1",
    clipPath: "url(#clip-Artboard_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_328",
    "data-name": "Group 328",
    transform: "translate(1432.907 -23838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M36.461,24.653a6.7,6.7,0,1,1-7.682-5.54A6.7,6.7,0,0,1,36.461,24.653Z",
    transform: "translate(-1446.516 23821)",
    fill: "#8e50a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M29.613,33.27a14.172,14.172,0,0,0-14.1,13.7H43.7A14.055,14.055,0,0,0,29.613,33.27Z",
    transform: "translate(-1446.516 23821)",
    fill: "#8e50a7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomerExperience);
export default __webpack_public_path__ + "static/media/icon-customer-experience.22a5e0422154c4dd9a31c56e7007225d.svg";
export { ForwardRef as ReactComponent };